import { Context, empty as emptyContext } from "./Context";

/**
 * @name Conversations
 * @memberof Conversations
 * @description This type represents the Conversations slice of the Global Redux Store.
 */
export type Conversations = {
  context: "buying" | "selling";
  isViewingArchived: boolean;
  offerModalIsOpen: boolean;
  offerModalConversationId: string | null | undefined;
  replyModalIsOpen: boolean;
  replyModalConversationId: string | null | undefined;
  individualLoadingConversations: Array<number>;
  buying: Context;
  selling: Context;
};

export const empty: Conversations = {
  context: "buying",
  isViewingArchived: false,
  offerModalIsOpen: false,
  offerModalConversationId: null,
  replyModalIsOpen: false,
  replyModalConversationId: null,
  individualLoadingConversations: [],
  buying: emptyContext,
  selling: emptyContext,
};
